<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const { result, message, search } = useRiverSearch()
const keyword = ref('')
const searchPointList = ref([])

watch([keyword, searchPointList], () => {
  search(searchPointList.value, keyword.value)
}, { immediate: true })

onMounted(async () => {
  const data = await $fetch('/api/search/list')
  searchPointList.value = data
})
</script>

<template>
  <div class="riverSearch">
    <div class="head">
      <SectionTitle title="ライブカメラ・地点を探す" />
    </div>
    <div class="content">
      <div class="input">
        <input
          v-model="keyword"
          type="text"
          placeholder="河川・所在地・地点名"
          @keydown.enter.prevent
        >
        <button>検索する</button>
      </div>
    </div>
    <RiverSearchPointCandidate
      v-show="keyword !== ''"
      :result="result"
      :message="message"
    />
  </div>
</template>

<style lang="scss" scoped>
.riverSearch {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    justify-content: space-between;
  }
  .content {
    .input {
      display: flex;
      align-items: stretch;
      width: 100%;
      padding: 5px 5px 5px 10px;
      border-radius: 6px;
      border: 1px solid #CCC;
      background-color: #FFF;
      input {
        flex: 1;
        color: #303030;
        font-size: 17px;
        font-weight: 600;
        line-height: 1em;
        outline: none;
      }
      button {
        display: none;
      }
    }
  }
}
@media (min-width: 830px) {
  .riverSearch {
    .content {
      .input {
        input {
          font-size: 16px;
        }
        button {
          padding: 4px 33px 4px 10px;
          background-image: url('https://gvs.weathernews.jp/onebox/img/icon/icon_mushimegane_white.svg');
          background-repeat: no-repeat;
          background-position: right 10px center;
          background-size: 18px;
          border-radius: 4px;
          background-color: #3569C0;
          color: #FFF;
          font-size: 12px;
          font-weight: 600;
          line-height: 2em;
        }
      }
    }
  }
}
</style>
